const STORAGE_KEY = 'gcodr_fingerprint'

export function getFingerprint(): string {
  let fp = localStorage.getItem(STORAGE_KEY)
  if (!fp) {
    fp = crypto.randomUUID()
    localStorage.setItem(STORAGE_KEY, fp)
  }
  return fp
}
